/**
 * Message type constants for paywall communication
 * Shared between parent and child implementations
 */
export const PAYWALL_MESSAGE_TYPES = {
  NAVIGATE_TO_ROUTE: "NAVIGATE_TO_ROUTE",
  IFRAME_INITIALIZE: "IFRAME_INITIALIZE", 
  AUTH_SUCCESS: "AUTH_SUCCESS",
  AUTH_PROFILE_NEEDED: "AUTH_PROFILE_NEEDED",
  AUTH_FAILED: "AUTH_FAILED",
  PROFILE_CREATED: "PROFILE_CREATED",
  PAYWALL_STATE_UPDATED: "PAYWALL_STATE_UPDATED",
} as const;

// Array of all paywall message types for type guards
export const PAYWALL_MESSAGE_TYPE_VALUES = Object.values(PAYWALL_MESSAGE_TYPES);